import React, { FunctionComponent, useState } from 'react';
import GoogleMap, { Coords, Props } from 'google-map-react';
import './geoMap.scss';
import { MapContainerProps } from './GeoMap';
import Loader from '../loader/Loader';
import { TimerIcon } from '../icons';
import Typography from '../typography/Typography';

type DirectionProps = {
  origin: Coords,
  destination: Coords
}

const GeoDirection: FunctionComponent<Props & MapContainerProps & DirectionProps> = ({
  origin,
  destination,
  apiKey,
  width,
  height,
  center = { lat: 0, lng: 0 },
  zoom = 12,
  position,
  className = '',
  options,
  timeStamp,
  loader,
}: any) => {
  const [loading, setLoading] = useState(true);

  const handleGoogleApiLoaded = (map: any, maps: any) => {
    const directionsService = new maps.DirectionsService();
    const directionsRenderer = new maps.DirectionsRenderer();
    directionsRenderer.setOptions({
      markerOptions: {
        clickable: false,
      },
    });
    directionsRenderer.setMap(map);
    directionsService.route({
      origin,
      destination,
      travelMode: 'DRIVING',
    }, (response: any, status: string) => {
      if (status === 'OK') {
        directionsRenderer.setDirections(response);
        // @ts-ignore
        const routePolyline = new google.maps.Polyline({
          path: response.routes[0].overview_path,
        });
        routePolyline.setMap(map);
      }
      else {
        console.log('Error', status);
      }
    });
  };

  const mapLoaded = () => {
    setLoading(false);
  };

  return (
    <div className={`geo-map ${className}`} style={{ width, height }}>
      {loading && (loader || <Loader />)}

      <GoogleMap
        center={center || position}
        defaultZoom={zoom}
        bootstrapURLKeys={{
          key: apiKey,
          libraries: ['drawing'],
        }}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map, maps }) => handleGoogleApiLoaded(map, maps)}
        onTilesLoaded={mapLoaded}
        options={{
          disableDefaultUI: true,
          draggable: false,
          keyboardShortcuts: false,
          clickableIcons: false,
          ...options,
        }}
      />
      {timeStamp && (
        <div className="time-box bg-color-blue5 light d-flex align-items-center">
          <TimerIcon
            width={24}
            height={24}
            color="light"
            direction="right"
            className="m-r-9"
          />
          <Typography variant="button" color="light">{`${timeStamp} min`}</Typography>
        </div>
      )}
    </div>
  );
};

export default GeoDirection;
